import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class TdoLeadtoolsService {
  constructor() {}

  verifyService(isDebug = false) {
    // To communicate with the DocumentsService, it must be running!
    // Change these parameters to match the path to the service.
    // lt.Document.DocumentFactory.serviceHost = "http://localhost:30000";
    lt.Document.DocumentFactory.serviceHost = 'https://ltservice1.tdox.dental';
    //lt.Document.DocumentFactory.serviceHost = 'http://localhost:40000';
    lt.Document.DocumentFactory.servicePath = '';
    lt.Document.DocumentFactory.serviceApiPath = 'api';

    console.log('service host ', lt.Document.DocumentFactory.serviceHost);

    /*Uncomment bellow for debugging*/
    if (isDebug) {
      const hasService =
        (lt.Document.DocumentFactory.serviceHost && lt.Document.DocumentFactory.serviceHost.length > 0) ||
        (lt.Document.DocumentFactory.servicePath && lt.Document.DocumentFactory.servicePath.length > 0);
      if (hasService) {

        lt.Document.DocumentFactory.verifyService()
          .done((response: lt.Document.ServiceStatus) => {
            let serviceInfo = 'Service name: \'' + response.serviceName + '\'';
            serviceInfo += ' version: \'' + response.serviceVersion + '\'';
            serviceInfo += ' platform: \'' + response.servicePlatform + '\'';
            serviceInfo += ' OS: \'' + response.serviceOperatingSystem + '\'';
            lt.LTHelper.log(serviceInfo);

            let message = [];

            // Check if the LEADTOOLS license on the server is usable, otherwise, show a warning
            if (!response.isLicenseChecked) {
              // The server has failed to check the license, could be an invalid license or one that does not exist
              message = ['Warning!', 'The LEADTOOLS License used in the service could not be found. This demo may not function as expected.'];
              window.alert(message.join('\n\n'));
              lt.LTHelper.logWarning(message.join(' '));
            } else if (response.isLicenseExpired) {
              // The server has detected that the license used has expired
              message = ['Warning!', 'The LEADTOOLS Kernel has expired. This demo may not function as expected.'];
              window.alert(message.join('\n\n'));
              lt.LTHelper.logWarning(message.join(' '));
            }

            if (!response.isCacheAccessible) {
              // The cache directory set in the .config for the server doesn't exist or has improper permissions
              message = ['Warning!', 'The server\'s cache directory does not exist or cannot be written to. This demo may not function as expected.'];
              window.alert(message.join('\n\n'));
              lt.LTHelper.logWarning(message.join(' '));
            }

            if (response.kernelType != null && response.kernelType != 'Release') {
              // If the kernel is not release, log it (for debugging)
              lt.LTHelper.log('Server LEADTOOLS Kernel type: ' + response.kernelType);
            }

            if (response.ocrEngineStatus !== lt.Document.OcrEngineStatus.ready) {
              // The OCR Engine on the service is not working properly
              if (response.ocrEngineStatus === lt.Document.OcrEngineStatus.unset) {
                lt.LTHelper.logWarning('The LEADTOOLS OCR Engine Runtime was not set on the service. OCR is not supported.');
              } else if (response.ocrEngineStatus === lt.Document.OcrEngineStatus.error) {
                lt.LTHelper.logError('The LEADTOOLS OCR Engine setup experienced an error. OCR is not supported.');
              }
            }

            // this.initLeadtoolsControls();

          })
          .fail((jqXHR, statusText, errorThrown) => {
            window.alert('Cannot reach the LEADTOOLS Document Service.\n\nPlease Make sure LEADTOOLS DocumentService is running(Examples/JS/Services/) and verify that the service path is correct, then refresh the application.');
            // this.endBusyOperation();
          });
      }
    }
  }
}
